import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Languages } from 'lucide-react';
import { animations } from '../animations';
import PlaceInput from '../../VehicleType/PlaceInput';
import PhoneInput from 'react-phone-input-2';
  
import {  Header,
    Body,
    FormGroup,
    Label,
    Error,
    ButtonGroup,
    Button } from '../StyledComponents';
  
export const LocationStep = ({
  startPoint,
  locationError,
  phone,
  phoneError,
  isEnglishSpeaker,
  onStartPointChange,
  onPhoneChange,
  onEnglishSpeakerChange,
  onNext
}) => {
  return (
    <motion.div {...animations.pageTransition}>
      <Header>
        <MapPin />
        <h2>Your Location</h2>
      </Header>
      <Body>
        <FormGroup>
          <Label>Starting Point</Label>
          <PlaceInput
            value={startPoint}
            onChanges={onStartPointChange}
            point={startPoint}
            error={locationError}
          />
          {locationError && <Error>{locationError}</Error>}
        </FormGroup>

        <FormGroup>
          <Label>Phone Number</Label>
          <PhoneInput
            country="et"
            value={phone}
            onChange={onPhoneChange}
            enableAreaCodes={true}
            containerClass="phone-input-container"
          />
          {phoneError && <Error>{phoneError}</Error>}
        </FormGroup>

        <FormGroup>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px',
            padding: '16px',
            border: '1px solid #d1d5db',
            borderRadius: '8px',
            backgroundColor: '#f9fafb'
          }}>
            <input
              type="checkbox"
              id="englishSpeaker"
              checked={isEnglishSpeaker}
              onChange={(e) => onEnglishSpeakerChange(e.target.checked)}
              style={{
                width: '18px',
                height: '18px',
                accentColor: '#dc2626'
              }}
            />
            <label 
              htmlFor="englishSpeaker" 
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '16px',
                color: '#374151',
                cursor: 'pointer',
                userSelect: 'none'
              }}
            >
              <Languages size={16} style={{ marginRight: '8px' }} />
              I need an English-speaking driver
            </label>
          </div>
          <div style={{
            fontSize: '14px',
            color: '#6b7280',
            marginTop: '8px',
            lineHeight: '1.4'
          }}>
            Check this box if you prefer to communicate with your driver in English. 
            If unchecked, any available driver will be assigned regardless of language.
          </div>
        </FormGroup>

        <ButtonGroup>
          <Button variant="secondary" disabled>
            Previous
          </Button>
          <Button
            variant="primary"
            onClick={onNext}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Next
          </Button>
        </ButtonGroup>
      </Body>
    </motion.div>
  );
};
 